export const contextColleague = {
    title: "Aucun patient | Un patient | {count} patients",
    search: {
      placeholder: "Filtrez les patients",
			title: "Filtrez la liste de patients affichée ci-dessous"
    }
}